import * as React from 'react';
import { FC } from 'react';
import { Container } from 'routes/landing/components/Container';
import { CONDITION_DESKTOP } from 'shared/common/constants';
import { containImageStyle } from 'shared/helpers';
import styled from 'styled-components';

interface IMobileBannerProps {}

// TODO: refactoring
export const MobileBanner: FC<IMobileBannerProps> = (props) => (
  <Container>
    <StyledWrapper>
      <StyledTitle>С приложением удобнее</StyledTitle>

      <StyledDescription>
        Оказывать консультации так же просто, как общаться в мессенджере!
        <br />
        <br />
        Настройте профиль эксперта на сайте Consulty и скачайте приложение, чтобы получать заявки от клиентов
        моментально и отвечать им, где и когда удобно.
      </StyledDescription>

      <StyledLinksWrapper>
        <StyledAppLink href="https://apps.apple.com/ru/app/consulty/id1590830075?l=en">
          <StyledAppImage src="/landing/store-apple.svg" alt="IOs" />
        </StyledAppLink>

        <StyledAppLink href="https://play.google.com/store/apps/details?id=com.consulty">
          <StyledAppImage src="/landing/store-google.svg" alt="Android" />
        </StyledAppLink>
      </StyledLinksWrapper>
    </StyledWrapper>
  </Container>
);

const StyledWrapper = styled.div({
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#8b33ff',
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  borderBottomLeftRadius: 20,
  paddingTop: 30,
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 314,
  marginTop: 90,
  marginBottom: 50,

  '&::before': {
    content: '""',
    position: 'absolute',
    bottom: -55,
    width: 223,
    height: 320,
    left: '50%',
    marginLeft: -111,
    ...containImageStyle('/img/2000experts/pic-hand-app@2x.png'),
  },

  [CONDITION_DESKTOP]: {
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
    borderBottomLeftRadius: 50,
    paddingTop: 90,
    paddingLeft: 591,
    paddingRight: 30,
    paddingBottom: 50,
    marginTop: 120,
    marginBottom: 120,

    '&::before': {
      bottom: -112,
      width: 449,
      height: 645,
      left: 0,
      marginLeft: 0,
    },
  },
});

const StyledTitle = styled.div({
  fontSize: 25,
  fontWeight: 'bold',
  lineHeight: 1.2,
  color: '#ffffff',
  marginBottom: 20,

  [CONDITION_DESKTOP]: {
    fontSize: 30,
  },
});

const StyledDescription = styled.div({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.33,
  color: '#ffffff',
  marginBottom: 30,

  [CONDITION_DESKTOP]: {
    fontSize: 18,
    lineHeight: 1.58,
  },
});

const StyledLinksWrapper = styled.div({
  marginBottom: 40,

  [CONDITION_DESKTOP]: {
    marginBottom: 60,
  },
});

const StyledAppLink = styled.a({
  display: 'inline-flex',
  verticalAlign: 'bottom',

  '& + &': {
    marginLeft: 10,
  },
});

const StyledAppImage = styled.img({
  height: 40,

  [CONDITION_DESKTOP]: {
    height: 60,
  },
});

// const StyledSMSText = styled.div({
//     fontSize: 15,
//     fontWeight: 500,
//     lineHeight: 1.33,
//     color: '#ffffff',
//     marginBottom: 15,

//     [CONDITION_DESKTOP]: {
//         fontSize: 17,
//         lineHeight: 1.47,
//     },
// });
